import {
  type ResultOf,
  type VariablesOf,
  graphql,
} from "@/data-access/graphql";
import { ShareVoiceSidebarFilterFragment } from "../fragments/segment-fragment";

export const ShareVoiceSidebarFilterQuery = graphql(
  `
  query ShareVoiceSidebar($categories: [ShareVoiceSidebarCategory!]) {
    shareVoiceSidebar(categories: $categories) {
      ...ShareVoiceSidebarFilterFragment
    }
  }
`,
  [ShareVoiceSidebarFilterFragment],
);

export type ShareVoiceSidebarFilter = ResultOf<
  typeof ShareVoiceSidebarFilterQuery
>["shareVoiceSidebar"];

export type ShareVoiceSidebarFilterVariables = VariablesOf<
  typeof ShareVoiceSidebarFilterQuery
>;

export type ShareVoiceSidebarCategory = NonNullable<
  VariablesOf<typeof ShareVoiceSidebarFilterQuery>["categories"]
>[number];
